import script from "./ReviewsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsView.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsView.vue?vue&type=style&index=0&id=f79f615c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f79f615c"]])

export default __exports__